/*
 *
 * LanguageProvider reducer
 *
 */

import { fromJS } from "immutable";
import {getLocalLanguage} from '../../../utils/localLanguage';
import { CHANGE_LOCALE } from "./constants";
//import { DEFAULT_LOCALE } from "./constants";

const initialState = fromJS({
  locale: getLocalLanguage()
});

function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set("locale", action.locale);
    default:
      return state;
  }
}

export default languageProviderReducer;
